export const getRangeDelta = (d1: number, d2: number) => {
  return d1 - d2;
};